import { filter, length, pipe, is, join, equals } from 'ramda';
import { IBindingFunction } from '../models/callback';

export const lengthBy = (condition: IBindingFunction<any, boolean>, arr: any[]) => length(filter(condition, arr));

export const concat = (...rest: Array<any>) => pipe(
  filter<any, 'array'>(is(String)),
  join(' ')
)(rest);

export const arrayEntriesEqual = <T>(a: T[], b: T[]) => equals(new Set(a), new Set(b));
